import React from 'react';

import auth from './Auth/Auth';
import walletManager from './_core/wallet-manager';


export default React.createContext({ auth, walletManager });
